// 게시글 본문의 첫 유튜브 영상 id. 앱(korehalal_app YoutubeInlinePlayer.videoIdFrom)과 같은 규칙.
const YOUTUBE_ID =
	/(?:youtube(?:-nocookie)?\.com\/(?:embed\/|shorts\/|live\/|watch\?(?:\S*?&)?v=)|youtu\.be\/)([A-Za-z0-9_-]{11})/i;

export const youtubeIdFrom = (text: string | null | undefined): string | null =>
	text?.match(YOUTUBE_ID)?.[1] ?? null;

// blog:sync 가 본문에 넣는 「▶ 영상 보기 / Watch: <유튜브 주소>」 줄. 영상은 플레이어로
// 보여주니 글자로는 숨긴다(본문 데이터에는 남아 있어야 플레이어가 영상을 찾는다).
// 번역문에서도 ▶ 와 주소는 그대로라 같은 규칙으로 걸린다. 사용자가 쓴 일반 링크는 그대로.
const VIDEO_LINE = /^[ \t]*▶[^\n]*(?:youtube(?:-nocookie)?\.com|youtu\.be)\/[^\n]*(?:\n+|$)/gim;

export const hideVideoLines = (text: string | null | undefined): string =>
	(text ?? '').replace(VIDEO_LINE, '').trimEnd();
